import React from 'react';
import { Box } from '@mui/material';
import AppHeader from './AppHeader';
import Footer from './Footer';

interface LayoutProps {
  children: React.ReactNode;
  showFooter?: boolean;
  footerVariant?: 'default' | 'minimal';
  downloadCount?: number;
  isAuthenticated?: boolean;
  userName?: string;
  onLoginClick?: () => void;
  onLogout?: () => void;
  onLogoClick?: () => void;
  cartItemCount?: number;
  onCartClick?: () => void;
  onFavoritesClick?: () => void;
  onDownloadsClick?: () => void;
  user?: { role?: string } | null;
}

const Layout: React.FC<LayoutProps> = ({
  children,
  showFooter = true,
  footerVariant = 'default',
  downloadCount = 0,
  isAuthenticated = false,
  userName = '',
  onLoginClick = () => {},
  onLogout = () => {},
  onLogoClick = () => {},
  cartItemCount = 0,
  onCartClick = () => {},
  onFavoritesClick = () => {},
  onDownloadsClick = () => {},
  user = null
}) => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      {/* Header */}
      <AppHeader
        downloadCount={downloadCount}
        isAuthenticated={isAuthenticated}
        onLoginClick={onLoginClick}
        onLogout={onLogout}
        userName={userName}
        onLogoClick={onLogoClick}
        cartItemCount={cartItemCount}
        onCartClick={onCartClick}
        onFavoritesClick={onFavoritesClick}
        onDownloadsClick={onDownloadsClick}
        user={user}
      />

      {/* Main Content */}
      <Box
        component="main"
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        {children}
      </Box>

      {/* Footer */}
      {showFooter && (
        <Footer variant={footerVariant} />
      )}
    </Box>
  );
};

export default Layout; 